var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.items),function(item){return _c('li',{key:item.label,class:item.class},[_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(_vm.$t(item.label)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }